import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@tiny/components";
import SegmentPerformanceContent from "./SegmentPerformanceContent";

export interface SegmentPerformanceDialogProps {
  open: boolean;
  onClose: () => void;
  segmentId: string;
}

function SegmentPerformanceDialog({
  open,
  onClose,
  segmentId,
}: SegmentPerformanceDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{ style: { backgroundColor: "#f9fafb" } }}
    >
      <DialogTitle>New Engager Performance</DialogTitle>
      <DialogContent>
        <SegmentPerformanceContent open={open} segmentId={segmentId} days={7} />
      </DialogContent>
    </Dialog>
  );
}

export default SegmentPerformanceDialog;
